export interface IFetchErrorParams {
  message: string;
  status: number;
  url?: string;
  options?: any;
}

export class FetchError extends Error {
  readonly status: number;
  readonly url?: string;
  readonly options?: any;

  constructor({ message, status, url, options }: IFetchErrorParams) {
    super(message);
    this.name = 'FetchError';
    this.status = status;
    this.url = url;
    this.options = options;
  }
}
